var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Box(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "48px",
    height: "48px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5,5c-1.36359,0 -2.5,1.13641 -2.5,2.5v6c0,1.17017 0.90084,2.03005 2,2.29102v20.70898c0,3.57194 2.92806,6.5 6.5,6.5h19c3.57194,0 6.5,-2.92806 6.5,-6.5v-20.70898c1.09916,-0.26097 2,-1.12085 2,-2.29102v-6c0,-1.36359 -1.13641,-2.5 -2.5,-2.5zM9,8h30v5h-30zM11,16h26v20.5c0,1.95006 -1.54994,3.5 -3.5,3.5h-19c-1.95006,0 -3.5,-1.54994 -3.5,-3.5zM19.5,22c-0.54095,-0.00765 -1.04412,0.27656 -1.31683,0.74381c-0.27271,0.46725 -0.27271,1.04514 0,1.51238c0.27271,0.46725 0.77588,0.75146 1.31683,0.74381h9c0.54095,0.00765 1.04412,-0.27656 1.31683,-0.74381c0.27271,-0.46725 0.27271,-1.04514 0,-1.51238c-0.27271,-0.46725 -0.77588,-0.75146 -1.31683,-0.74381z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Box);
export default __webpack_public_path__ + "static/media/icons8-box.8a1d22e05860296996a4d02ca2a9658f.svg";
export { ForwardRef as ReactComponent };